import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, inject, input,OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Directive({
  selector: '[appBgImgFallback]',
  standalone: true,
})
export class BgFallbackDirective implements OnInit {
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly deviceService = inject(DeviceDetectorService);
  private readonly platformId = inject(PLATFORM_ID);

  readonly primaryBgImageUrl = input<string>('');
  readonly fallbackBgImageUrl = input<string>('');
  readonly tabletBgImageUrl = input<string>('');
  readonly fallbackTabletBgImageUrl = input<string>('');
  readonly mobileBgImageUrl = input<string>('');
  readonly fallbackMobileBgImageUrl = input<string>('');

  ngOnInit(): void {
    this.setResponsiveBackgroundImage();
  }

  private setResponsiveBackgroundImage(): void {
    if (isPlatformBrowser(this.platformId)) {
      const img = new Image();
      const deviceImageUrls = this.getDeviceSpecificImages();

      img.src = deviceImageUrls.primary;

      img.onload = () => {
        this.setBackgroundImage(deviceImageUrls.primary);
      };

      img.onerror = () => {
        this.setBackgroundImage(deviceImageUrls.fallback);
      };
    }
  }

  private getDeviceSpecificImages(): { primary: string; fallback: string } {
    if (this.deviceService.isMobile()) {
      return {
        primary: this.mobileBgImageUrl() || this.primaryBgImageUrl(),
        fallback: this.fallbackMobileBgImageUrl() || this.fallbackBgImageUrl(),
      };
    } else if (this.deviceService.isTablet()) {
      return {
        primary: this.tabletBgImageUrl() || this.primaryBgImageUrl(),
        fallback: this.fallbackTabletBgImageUrl() || this.fallbackBgImageUrl(),
      };
    } else {
      return {
        primary: this.primaryBgImageUrl(),
        fallback: this.fallbackBgImageUrl(),
      };
    }
  }

  setBackgroundImage(url: string): void {
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.setStyle(
        this.el.nativeElement,
        'background-image',
        `url(${url})`,
      );
    }
  }
}
